<template>
  <v-dialog
      v-model="dialog"
      hide-overlay
      fullscreen
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeLogDialog">
          <v-icon large color="primary">close</v-icon>
        </v-btn>
      </v-col>

      <v-card-text>
        <div class="px-5 pb-3">
          <h3>{{ title }}</h3>
        </div>
        <v-card class="overflow-y-auto pa-2 mb-3" color="#f8f8f8" max-height="750" width="100%" >
            <p class="text-pre-wrap">{{ log }}</p>
        </v-card>
        <BaseButton

            color="primary"
            :btn-text="$t('buttons:save')"
            @clickedButton="saveLog()"
        />
        <BaseButton
            color="grey"
            :btn-text="$t('buttons:back')"
            @clickedButton="closeLogDialog()"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import BaseButton from "@/modules/core/components/Base/BaseButton.vue";
import DocumentationService from "@/modules/core/services/documentation-service";

export default {
  name: "ImportLogDialog",
  components: {BaseButton},
  props: {
    title: String,
    log: String,
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    openLogDialog() {
      this.dialog = true;
    },
    closeLogDialog() {
      this.dialog = false;
    },
    saveLog() {
      DocumentationService.download(this.title + ".txt", this.log);
    }
  }
}
</script>

<style scoped>

</style>